import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangElIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.348 16.002h11.304l.004-.003H3.344l.004.003Z",
				fill: "#3757A6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.118 3.989h4.359a9.05 9.05 0 0 0-1.838-2.002h-3.235c.286.578.523 1.256.714 2.002Zm.549 4.003h5.276a8.963 8.963 0 0 0-.46-2.002h-4.986c.085.65.142 1.322.17 2.002Zm-.169 4.004h4.99c.224-.638.38-1.308.456-2.002h-5.276c-.028.68-.084 1.353-.17 2.002Zm-1.088 4.002h3.246a9.053 9.053 0 0 0 1.83-2H12.12a10.33 10.33 0 0 1-.71 2Z",
				fill: "#EFECEC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.12 1.988h3.519A8.96 8.96 0 0 0 9 0h-.028c1.021.006 1.547.773 2.147 1.988Zm1.136 4.002h5.227a8.96 8.96 0 0 0-1.006-2h-4.6c.16.626.286 1.3.379 2Zm5.687 2.002h-5.545a24.25 24.25 0 0 1 0 2.002h5.546a9.071 9.071 0 0 0-.001-2.002Zm-6.111 6.006h4.653a9.018 9.018 0 0 0 1.003-2.002h-5.279a17.428 17.428 0 0 1-.377 2.002ZM8.972 18H9a8.96 8.96 0 0 0 5.652-1.998h-3.509c-.6 1.22-1.147 1.992-2.171 1.998Z",
				fill: "#3757A6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.404 1.988C10.804.774 9.994.007 8.972 0a8.959 8.959 0 0 0-5.61 1.987h8.042Z",
				fill: "#4166AF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.404 1.987H3.361A9.055 9.055 0 0 0 1.523 3.99h10.595a10.29 10.29 0 0 0-.714-2.002Z",
				fill: "#EFEFEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.118 3.99H1.523a8.96 8.96 0 0 0-1.006 2h11.98a17.4 17.4 0 0 0-.38-2Z",
				fill: "#4166AF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.517 5.99a8.957 8.957 0 0 0-.46 2.002h12.61a22.41 22.41 0 0 0-.17-2.002H.517Z",
				fill: "#EFEFEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 9c0 .336.02.667.056.994h12.612a24.25 24.25 0 0 0 0-2.002H.057A9.118 9.118 0 0 0 0 9Z",
				fill: "#4166AF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.513 11.996h11.985c.086-.65.142-1.322.17-2.002H.056a8.94 8.94 0 0 0 .457 2.002Z",
				fill: "#EFEFEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.515 13.998h10.606c.159-.627.285-1.3.377-2.002H.513a8.95 8.95 0 0 0 1.002 2.002Z",
				fill: "#4166AF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.515 13.997A9.043 9.043 0 0 0 3.345 16h8.065a10.33 10.33 0 0 0 .71-2.002H1.516Z",
				fill: "#EFEFEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.972 18c1.024-.006 1.836-.778 2.437-1.998H3.348A8.962 8.962 0 0 0 8.972 18Z",
				fill: "#4166AF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 0a9 9 0 0 0-9 9l.056.994H9V0Z",
				fill: "#3757A6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.76 1.685a9.055 9.055 0 0 0-2.242 2.312h2.243V1.685ZM.52 5.984A8.987 8.987 0 0 0 0 9l.056.994h3.705v-4.01H.52ZM9 3.997V0a8.974 8.974 0 0 0-3.252.608v3.39H9Zm0 1.986H5.748v4.01H9v-4.01Z",
				fill: "#3757A6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.748 3.997V.608A8.964 8.964 0 0 0 3.76 1.684v2.313H1.518A8.968 8.968 0 0 0 .52 5.984h3.24v4.081h1.987V5.984H9V3.997H5.748Z",
				fill: "#EFEFEF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangElIconmin);
export { ForwardRef as ReactComponent };
